@if (!errorSavingChanges) {
	<div class="pop-up-dialog-v2">
		<div class="header-container">
			<h3>
				<ng-container i18n="@@saveChangesDialog-saveHeader">Save</ng-container> |
				<span i18n="@@saveChangesDialog-detailsHeader" class="non-bold-text">Billing Details</span>
			</h3>
			@if (confirmDisabled) {
				<mat-spinner diameter="25" class="loading-spinner"></mat-spinner>
			}
		</div>
		<mat-divider></mat-divider>
		<mat-dialog-content>
			<div i18n="@@saveChangesDialog-Confirmation">Are you sure you want to save your changes?</div>
		</mat-dialog-content>
		<mat-dialog-actions>
			<button
				(click)="onCloseClicked()"
				class="secondary-small-button"
				i18n="@@saveChangesDialog-Cancel"
				data-automation-id="save-changes-dialog-cancel-button"
			>
				Cancel
			</button>
			<button
				(click)="onConfirmClicked()"
				i18n="@@saveChangesDialog-Confirm"
				class="primary-small-button"
				data-automation-id="save-changes-dialog-confirm-button"
			>
				Confirm
			</button>
		</mat-dialog-actions>
	</div>
}

@if (errorSavingChanges) {
	<div class="pop-up-dialog-v2">
		<h3 i18n="@@saveChangesDialog-errorSavingChangesHeader">Error!</h3>
		<mat-divider></mat-divider>
		<mat-dialog-content>
			<div i18n="@@saveChangesDialog-errorSavingChangesDesc">
				Could not save your changes at this time. Please try again.
			</div>
		</mat-dialog-content>
		<mat-dialog-actions>
			<button
				(click)="onCloseClicked()"
				class="primary-small-button"
				i18n="@@saveChangesDialog-errorSavingChangesConfirm"
				data-automation-id="save-changes-dialog-ok-button"
			>
				Ok
			</button>
		</mat-dialog-actions>
	</div>
}
